/** @jsx jsx */
import { jsx } from '@emotion/core';
import Tooltip from '../../molecules/Tooltip';
import Error from './Error';
import { labelStyles, Field, FieldBody, Text } from './Field.styles';
import { EditableField as Props } from './Field.types';

const EditableField = ({
  tag,
  label,
  labelWidth,
  stacked = false,
  isEditing = true,
  inputRenderer,
  textRenderer,
  toolTip = {},
  required,
  error,
  touched,
}: Props) => (
  <Field stacked={stacked}>
    {/* eslint-disable-next-line react/no-unknown-property */}
    <label htmlFor={tag} css={labelStyles({ width: labelWidth })}>
      <span>
        {label}&nbsp;
        {required && isEditing && <span data-test-id="required">*</span>}
      </span>
      {toolTip.message && <Tooltip message={toolTip.message!} />}
    </label>
    <FieldBody stacked={stacked} isEditing={isEditing}>
      {isEditing && inputRenderer(error != null && touched)}
      {!isEditing && typeof textRenderer === 'string' && (
        <Text>{textRenderer}</Text>
      )}
      {!isEditing && typeof textRenderer !== 'string' && textRenderer}
      {error && touched && <Error error={error} />}
    </FieldBody>
  </Field>
);

export default EditableField;
